window.dataLayer = window.dataLayer || [];

const countryToRegions = {
	'AF' : 'Asia',
	'AX' : 'Europe',
	'AL' : 'Europe',
	'DZ' : 'Africa',
	'AS' : 'Oceania',
	'AD' : 'Europe',
	'AO' : 'Africa',
	'AI' : 'Americas',
	'AG' : 'Americas',
	'AR' : 'Americas',
	'AM' : 'Asia',
	'AW' : 'Americas',
	'AU' : 'Oceania',
	'AT' : 'Europe',
	'AZ' : 'Asia',
	'BS' : 'Americas',
	'BH' : 'Asia',
	'BD' : 'Asia',
	'BB' : 'Americas',
	'BY' : 'Europe',
	'BE' : 'Europe',
	'BZ' : 'Americas',
	'BJ' : 'Africa',
	'BM' : 'Americas',
	'BT' : 'Asia',
	'BO' : 'Americas',
	'BQ' : 'Americas',
	'BA' : 'Europe',
	'BW' : 'Africa',
	'BV' : 'Americas',
	'BR' : 'Americas',
	'IO' : 'Africa',
	'BN' : 'Asia',
	'BG' : 'Europe',
	'BF' : 'Africa',
	'BI' : 'Africa',
	'CV' : 'Africa',
	'KH' : 'Asia',
	'CM' : 'Africa',
	'CA' : 'Americas',
	'KY' : 'Americas',
	'CF' : 'Africa',
	'TD' : 'Africa',
	'CL' : 'Americas',
	'CN' : 'Asia',
	'CX' : 'Oceania',
	'CC' : 'Oceania',
	'CO' : 'Americas',
	'KM' : 'Africa',
	'CG' : 'Africa',
	'CD' : 'Africa',
	'CK' : 'Oceania',
	'CR' : 'Americas',
	'CI' : 'Africa',
	'HR' : 'Europe',
	'CU' : 'Americas',
	'CW' : 'Americas',
	'CY' : 'Asia',
	'CZ' : 'Europe',
	'DK' : 'Europe',
	'DJ' : 'Africa',
	'DM' : 'Americas',
	'DO' : 'Americas',
	'EC' : 'Americas',
	'EG' : 'Africa',
	'SV' : 'Americas',
	'GQ' : 'Africa',
	'ER' : 'Africa',
	'EE' : 'Europe',
	'SZ' : 'Africa',
	'ET' : 'Africa',
	'FK' : 'Americas',
	'FO' : 'Europe',
	'FJ' : 'Oceania',
	'FI' : 'Europe',
	'FR' : 'Europe',
	'GF' : 'Americas',
	'PF' : 'Oceania',
	'TF' : 'Africa',
	'GA' : 'Africa',
	'GM' : 'Africa',
	'GE' : 'Asia',
	'DE' : 'Europe',
	'GH' : 'Africa',
	'GI' : 'Europe',
	'GR' : 'Europe',
	'GL' : 'Americas',
	'GD' : 'Americas',
	'GP' : 'Americas',
	'GU' : 'Oceania',
	'GT' : 'Americas',
	'GG' : 'Europe',
	'GN' : 'Africa',
	'GW' : 'Africa',
	'GY' : 'Americas',
	'HT' : 'Americas',
	'HM' : 'Oceania',
	'VA' : 'Europe',
	'HN' : 'Americas',
	'HK' : 'Asia',
	'HU' : 'Europe',
	'IS' : 'Europe',
	'IN' : 'Asia',
	'ID' : 'Asia',
	'IR' : 'Asia',
	'IQ' : 'Asia',
	'IE' : 'Europe',
	'IM' : 'Europe',
	'IL' : 'Asia',
	'IT' : 'Europe',
	'JM' : 'Americas',
	'JP' : 'Asia',
	'JE' : 'Europe',
	'JO' : 'Asia',
	'KZ' : 'Asia',
	'KE' : 'Africa',
	'KI' : 'Oceania',
	'KP' : 'Asia',
	'KR' : 'Asia',
	'KW' : 'Asia',
	'KG' : 'Asia',
	'LA' : 'Asia',
	'LV' : 'Europe',
	'LB' : 'Asia',
	'LS' : 'Africa',
	'LR' : 'Africa',
	'LY' : 'Africa',
	'LI' : 'Europe',
	'LT' : 'Europe',
	'LU' : 'Europe',
	'MO' : 'Asia',
	'MG' : 'Africa',
	'MW' : 'Africa',
	'MY' : 'Asia',
	'MV' : 'Asia',
	'ML' : 'Africa',
	'MT' : 'Europe',
	'MH' : 'Oceania',
	'MQ' : 'Americas',
	'MR' : 'Africa',
	'MU' : 'Africa',
	'YT' : 'Africa',
	'MX' : 'Americas',
	'FM' : 'Oceania',
	'MD' : 'Europe',
	'MC' : 'Europe',
	'MN' : 'Asia',
	'ME' : 'Europe',
	'MS' : 'Americas',
	'MA' : 'Africa',
	'MZ' : 'Africa',
	'MM' : 'Asia',
	'NA' : 'Africa',
	'NR' : 'Oceania',
	'NP' : 'Asia',
	'NL' : 'Europe',
	'NC' : 'Oceania',
	'NZ' : 'Oceania',
	'NI' : 'Americas',
	'NE' : 'Africa',
	'NG' : 'Africa',
	'NU' : 'Oceania',
	'NF' : 'Oceania',
	'MK' : 'Europe',
	'MP' : 'Oceania',
	'NO' : 'Europe',
	'OM' : 'Asia',
	'PK' : 'Asia',
	'PW' : 'Oceania',
	'PS' : 'Asia',
	'PA' : 'Americas',
	'PG' : 'Oceania',
	'PY' : 'Americas',
	'PE' : 'Americas',
	'PH' : 'Asia',
	'PN' : 'Oceania',
	'PL' : 'Europe',
	'PT' : 'Europe',
	'PR' : 'Americas',
	'QA' : 'Asia',
	'RE' : 'Africa',
	'RO' : 'Europe',
	'RU' : 'Europe',
	'RW' : 'Africa',
	'BL' : 'Americas',
	'SH' : 'Africa',
	'KN' : 'Americas',
	'LC' : 'Americas',
	'MF' : 'Americas',
	'PM' : 'Americas',
	'VC' : 'Americas',
	'WS' : 'Oceania',
	'SM' : 'Europe',
	'ST' : 'Africa',
	'SA' : 'Asia',
	'SN' : 'Africa',
	'RS' : 'Europe',
	'SC' : 'Africa',
	'SL' : 'Africa',
	'SG' : 'Asia',
	'SX' : 'Americas',
	'SK' : 'Europe',
	'SI' : 'Europe',
	'SB' : 'Oceania',
	'SO' : 'Africa',
	'ZA' : 'Africa',
	'GS' : 'Americas',
	'SS' : 'Africa',
	'ES' : 'Europe',
	'LK' : 'Asia',
	'SD' : 'Africa',
	'SR' : 'Americas',
	'SJ' : 'Europe',
	'SE' : 'Europe',
	'CH' : 'Europe',
	'SY' : 'Asia',
	'TW' : 'Asia',
	'TJ' : 'Asia',
	'TZ' : 'Africa',
	'TH' : 'Asia',
	'TL' : 'Asia',
	'TG' : 'Africa',
	'TK' : 'Oceania',
	'TO' : 'Oceania',
	'TT' : 'Americas',
	'TN' : 'Africa',
	'TR' : 'Asia',
	'TM' : 'Asia',
	'TC' : 'Americas',
	'TV' : 'Oceania',
	'UG' : 'Africa',
	'UA' : 'Europe',
	'AE' : 'Asia',
	'GB' : 'Europe',
	'US' : 'Americas',
	'UM' : 'Oceania',
	'UY' : 'Americas',
	'UZ' : 'Asia',
	'VU' : 'Oceania',
	'VE' : 'Americas',
	'VN' : 'Asia',
	'VG' : 'Americas',
	'VI' : 'Americas',
	'WF' : 'Oceania',
	'EH' : 'Africa',
	'YE' : 'Asia',
	'ZM' : 'Africa',
	'ZW' : 'Africa',
};


const addDLEvent = (event, category=null, action=null, label=null, value=0) => {
	const newEvent = {
		'event': event,
		'ga_event': {
			'category': category,
			'action': action,
			'label': label,
			'value': value,
			'nonInteraction': 0
		}
	};
	pushToDL(newEvent);
};

const pushToDL = (event) => {
	console.log(event);
	window.dataLayer.push(event);
};


let subdomain = window.location.host.split('.').shift();

switch (subdomain) {
	case 'www':
		subdomain = 'global';
		break;
	// case 'uk':
	// 	subdomain = 'gb';
	// 	break;
	default:
		// discarded - global locale only
		subdomain = 'global';
		break;
}

const getRegion = () => {
	let { country } = document.querySelector('body').dataset;

	if(!country) country = 'GB';

	let region = '';
	if(countryToRegions[country.toUpperCase()]) region = countryToRegions[country.toUpperCase()];
	return region;
}

const getPageType = () => {
	const { type } = document.querySelector('body').dataset;
	return type || 'Other';
}

const getParents = (obj) => {
	let a = obj;
	const els = [];
	while (a) {
		els.unshift(a);
		a = a.parentNode;
	}
	return els;
}


/**
 * Main page view
 * @type {{site: {country: string, region: string, brand: string}, page: {name: string, type: string}, event: string}}
 */
const pageLoadEvent = {
	/* Global Data */
	event: 'siteDataLoaded',
	site: {
		'country': subdomain,
		'brand': 'Discarded Spirits',
		'region': getRegion()
	},
	page: {
		'type': getPageType(),
		'name': document.title
	}
};

pushToDL(pageLoadEvent);



// track links
document.querySelectorAll('a').forEach(item => {
    item.addEventListener('click', (e) => {
        const elAnchor = e.target.href ? e.target : e.target.closest("a");
        const href = elAnchor.href;
        const linkText = (elAnchor.getAttribute('title') && elAnchor.getAttribute('title') != '') ? elAnchor.getAttribute('title') : elAnchor.innerText.replace(/(\r\n|\n|\r)/gm," ");

        let event = 'otherClicks';
        let category = 'Other Click';
        let action = null;
        let label = null;

        switch (true) {
            /** social links **/
            case (href.indexOf('facebook') !== -1):
            case (href.indexOf('twitter') !== -1):
            case (href.indexOf('instagram') !== -1):
            case (href.indexOf('snapchat') !== -1):
            case (href.indexOf('pinterest') !== -1):
				case (href.indexOf('youtube') !== -1):
                event = 'socialClicks';
                category = 'Social Links';
                action = (elAnchor.closest("header") ? 'Header' : 'Footer')
                label = linkText;
                break;

            /** retailer links **/
            case (href.indexOf('drizly') !== -1):
            case (href.indexOf('instacart') !== -1):
            case (href.indexOf('reservebar') !== -1):
            case (href.indexOf('clink') !== -1):
            case (href.indexOf('bevmo') !== -1):
            case (href.indexOf('wine') !== -1):
            case (href.indexOf('clinkspirit') !== -1):
                event = 'extRetailerClicks';
                category = 'External Retailer Links';
                switch (true) {
                    case (href.indexOf('drizly') !== -1):
                        action = 'Drizly';
                        break;
                    case (href.indexOf('instacart') !== -1):
                        action = 'Instacart';
                        break;
                    case (href.indexOf('reservebar') !== -1):
                        action = 'Reserve bar';
                        break;
                    case (href.indexOf('clink') !== -1):
                        action = 'Clink Spirit';
                        break;
                    case (href.indexOf('bevmo') !== -1):
                        action = 'Bevmo';
                        break;
                    case (href.indexOf('totalwine') !== -1):
                        action = 'Total Wine';
                        break;
                    case (href.indexOf('wine') !== -1):
                        action = 'Wine.com';
                        break;
                    case (href.indexOf('clinkspirit') !== -1):
                        action = 'Click*';
                        break;
                }

                if (elAnchor.parentNode.querySelector("h1, h2, h3, h4, h5, h6") && elAnchor.parentNode.querySelector("h1, h2, h3, h4, h5, h6").innerText != '') {
                    label = elAnchor.parentNode.querySelector("h1, h2, h3, h4, h5, h6").innerText.replace(/(\r\n|\n|\r)/gm, ' ');
                } else {
                    label = document.title;
                }
                break;

            default:
                event = "ctaClicks";
				category = "Internal CTA Clicks";
                action = linkText;

                if (elAnchor.parentNode.querySelector("h1, h2, h3, h4, h5, h6") && elAnchor.parentNode.querySelector("h1, h2, h3, h4, h5, h6").innerText != '') {
                    label = elAnchor.parentNode.querySelector("h1, h2, h3, h4, h5, h6").innerText.replace(/(\r\n|\n|\r)/gm, ' ');
                } else if (elAnchor.closest("header")) {
                    label = 'Header';
                } else if (elAnchor.closest("footer")) {
                    label = 'Footer';
                } else {
                    label = linkText + ' Main';
                }
                break;
        }

        // console.log(href, event, category, action, label);
        addDLEvent(event, category, action, label);
    });
});